// src/common/pages/authorValidation/UsoDeDatos.tsx
import React, { useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Link, Typography } from "@mui/material";
import type { TextosPagina } from "./textos";

/**
 * El enlace discreto al pie de todos los pasos y la ventana que abre: para qué
 * se usan los datos, los derechos de la Ley 25.326 y la leyenda de la AAIP.
 * Es lo único que explica; los pasos no tienen bloques explicativos.
 */
export const UsoDeDatos: React.FC<{ textos: TextosPagina }> = ({ textos }) => {
  const [abierto, setAbierto] = useState(false);
  return (
    <>
      <Link component="button" type="button" variant="body2" color="text.secondary" onClick={() => setAbierto(true)}>
        {textos.usoTitulo}
      </Link>
      <Dialog open={abierto} onClose={() => setAbierto(false)} maxWidth="sm" fullWidth>
        <DialogTitle>{textos.usoTitulo}</DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ mb: 2 }}>
            {textos.usoProposito}
          </Typography>
          <Typography variant="body2">{textos.usoDerechos}</Typography>
          <Typography variant="caption" color="text.secondary" component="div" sx={{ mt: 2 }}>
            {textos.usoAaip}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setAbierto(false)}>{textos.cerrar}</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
